/**
 * LeadMagnetCTA - Category-specific lead magnet CTAs for blog posts
 */

import { Link } from "react-router-dom";
import type { CategorySlug } from "../../lib/blog";

interface LeadMagnetCTAProps {
  category?: CategorySlug;
}

const LEAD_MAGNETS: Record<CategorySlug, {
  title: string;
  description: string;
  buttonText: string;
  leadType: string;
}> = {
  "early-coding": {
    title: "Free 5-Day Coding Challenge",
    description:
      "Get daily coding activities for your preschooler delivered to your inbox. Start teaching computational thinking today!",
    buttonText: "Start the Challenge",
    leadType: "coding-challenge",
  },
  "screen-time": {
    title: "Parent's Guide to Guilt-Free Screen Time",
    description:
      "Download our free guide to making screen time educational and purposeful. Includes app evaluation checklist.",
    buttonText: "Get the Guide",
    leadType: "screen-time-guide",
  },
  "kindergarten-readiness": {
    title: "Kindergarten Readiness Checklist",
    description:
      "A printable checklist of skills your child needs before kindergarten, plus activity ideas for any gaps.",
    buttonText: "Download Checklist",
    leadType: "k-readiness",
  },
  "play-based-learning": {
    title: "Character Activity Packs",
    description:
      "Printable activities featuring Luna, Petal, Prism, Whiskers, and Pixel. Learning through play, at home!",
    buttonText: "Get the Activities",
    leadType: "activity-packs",
  },
};

const DEFAULT_CTA = {
  title: "See What JumpBean Can Do",
  description:
    "Your child can master math, spelling, patterns, typing, and coding basics—through magical adventures they'll love.",
  buttonText: "Try Free",
  leadType: "general",
};

export function LeadMagnetCTA({ category }: LeadMagnetCTAProps) {
  const cta = category ? LEAD_MAGNETS[category] : DEFAULT_CTA;
  const ctaUrl = `/register?ref=blog&lead=${cta.leadType}`;

  return (
    <div className="text-center">
      <h3 className="font-display font-bold text-display-sm text-neutral-900 mb-3">
        {cta.title}
      </h3>
      <p className="font-body text-body-md text-neutral-600 mb-6 max-w-lg mx-auto">
        {cta.description}
      </p>
      <Link
        to={ctaUrl}
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full
                 font-display font-bold text-neutral-900
                 bg-sunshine-400 hover:bg-sunshine-500
                 transition-colors shadow-playful hover:shadow-playful-lg"
      >
        {cta.buttonText}
        <span className="text-lg">→</span>
      </Link>
    </div>
  );
}
